import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../../../../components/useTable";
//UI
import { Input } from "../../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";

const headCells = [
  {
    id: "codConcepto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Concepto",
    textAlign: "center",
  },
  {
    id: "nomConcepto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nom. Concepto",
    textAlign: "center",
  },
  {
    id: "asignaciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Asignaciones",
    textAlign: "center",
  },
  {
    id: "deducciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Deducciones",
    textAlign: "center",
  },
];

export default function ActualizarMontoConceptosVacaciones({
  show,
  setShow,
  setTabla,
}) {
  const [tableData, setTableData] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    tableData,
    headCells,
    filterFn
  );

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Actualizar Vacaciones</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap align-items-center">
        <div className="col-12 m-0 p-0">
          <div className="col-2 m-0 mb-2 p-0">
            <Input label="Id Vacaciones:" />
          </div>
        </div>
        <div className="col-2 m-0 mb-2 p-0">
          <Input label="Cod. Integrante:" />
        </div>
        <div className="col-10 m-0 mb-2 p-0 pl-2">
          <Input label="Nombre:" />
        </div>
        <div className="col-3 m-0 mb-2 p-0">
          <Input label="Fec. Salida:" type="date" />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label="Días Disfrute:" />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label="Fec. Retorno:" type="date" />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label="Días por Año de Servicio:" />
        </div>
        <fieldset className="col-6 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded">
          <legend className="w-auto float-none m-0">
            Período que Corresponde (Años)
          </legend>
          <Input label="Fec. Inicio:" type="date" />
          <Input label="Fec. Fin:" type="date" />
        </fieldset>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label="Días Feriados:" />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label="Días Descanso:" />
        </div>
        <div className="col-10 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {tableData &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={index}></tr>
                ))}
            </tbody>
          </TblContainer>
        </div>
        <div className="col-2 m-0 p-0 pl-2">
          <Input label = 'Monto:' inputClassName = 'text-end' placeholder = '0.00' />
        </div>
        <div className="col-3 m-0 p-0">
          <Input />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label = 'Asignaciones:' />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label = 'Deducciones:' />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label = 'Total:' inputClassName = 'text-end' placeholder = '0.00'/>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
